import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["queryType", "arParams", "sqlParams"]

  connect() {
    this.toggle()
  }

  toggle() {
    const val = this.queryTypeTarget.value
    if (val === "ar") {
      this.arParamsTarget.classList.remove("hidden")
      this.sqlParamsTarget.classList.add("hidden")
    } else if (val === "sql") {
      this.sqlParamsTarget.classList.remove("hidden")
      this.arParamsTarget.classList.add("hidden")
    } else {
      this.arParamsTarget.classList.add("hidden")
      this.sqlParamsTarget.classList.add("hidden")
    }
  }
}